function config() {
    if (typeof window !== 'undefined' && window.__ADMIN_URLS__) {
        return window.__ADMIN_URLS__;
    }

    return { legacyPrefix: 'a3f91c2e8b4d7019', filamentPath: 'a3f91c2e8b4d7019/v2' };
}

export function legacyUrl(path = '') {
    const { legacyPrefix } = config();
    const segment = String(path).replace(/^\//, '');

    return '/' + legacyPrefix + (segment ? '/' + segment : '');
}

export function filamentUrl(path = '') {
    const { filamentPath } = config();
    const segment = String(path).replace(/^\//, '');

    return '/' + filamentPath + (segment ? '/' + segment : '');
}
